import React from "react";
import { AbsoluteFill, Sequence } from "remotion";
import { SCENES } from "./data/scenes";
import TimelineHUD from "./components/TimelineHUD";
import Scene0Boot from "./scenes/Scene0Boot";
import Scene1Map from "./scenes/Scene1Map";
import Scene2ZipCo from "./scenes/Scene2ZipCo";
import Scene3PaloDeck from "./scenes/Scene3PaloDeck";
import Scene44Mation from "./scenes/Scene44Mation";
import Scene5SeniorEra from "./scenes/Scene5SeniorEra";
import Scene6Constellation from "./scenes/Scene6Constellation";
import Scene7Contact from "./scenes/Scene7Contact";

// Root composition: one scroll-scrubbed timeline of 8 scenes.
// Scroll position = playhead; see AdventurePage/useScrollFrame.
const ResumeAdventure: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: "#181818" }}>
      <Sequence
        from={SCENES.boot.from}
        durationInFrames={SCENES.boot.duration}
        layout="absolute-fill"
        name="0 Boot"
      >
        <Scene0Boot />
      </Sequence>
      <Sequence
        from={SCENES.map.from}
        durationInFrames={SCENES.map.duration}
        layout="absolute-fill"
        name="1 Map"
      >
        <Scene1Map />
      </Sequence>
      <Sequence
        from={SCENES.zip.from}
        durationInFrames={SCENES.zip.duration}
        layout="absolute-fill"
        name="2 Zip Co"
      >
        <Scene2ZipCo />
      </Sequence>
      <Sequence
        from={SCENES.paloDeck.from}
        durationInFrames={SCENES.paloDeck.duration}
        layout="absolute-fill"
        name="3 Palo deck"
      >
        <Scene3PaloDeck />
      </Sequence>
      <Sequence
        from={SCENES.fourMation.from}
        durationInFrames={SCENES.fourMation.duration}
        layout="absolute-fill"
        name="4 4Mation"
      >
        <Scene44Mation />
      </Sequence>
      <Sequence
        from={SCENES.seniorEra.from}
        durationInFrames={SCENES.seniorEra.duration}
        layout="absolute-fill"
        name="5 Senior era"
      >
        <Scene5SeniorEra />
      </Sequence>
      <Sequence
        from={SCENES.constellation.from}
        durationInFrames={SCENES.constellation.duration}
        layout="absolute-fill"
        name="6 Constellation"
      >
        <Scene6Constellation />
      </Sequence>
      <Sequence
        from={SCENES.contact.from}
        durationInFrames={SCENES.contact.duration}
        layout="absolute-fill"
        name="7 Contact"
      >
        <Scene7Contact />
      </Sequence>
      <TimelineHUD />
    </AbsoluteFill>
  );
};

export default ResumeAdventure;
